/**
 * LogRocket Session Hash Injector for Shopify Cart Adds (Sync Production)
 * 
 * Purpose: On click of add-to-cart buttons, synchronously checks for LogRocket.sessionURL,
 *          appends `rocket={hash}` to the `data-link` attr if available, then lets the event
 *          bubble naturally to your jQuery handler (which adds cart_hash and proceeds).
 *          No preventDefault or re-trigger—avoids loops/races with delegated handlers.
 *          Enables backend to capture hash for direct replay links.
 * 
 * Key Features:
 * - Sync extraction via LogRocket.sessionURL (ready by click time in practice).
 * - Handles child clicks via closest().
 * - Appends rocket before cart_hash (params accumulate safely).
 * - Fallback: No param if sessionURL not ready (rare; tracks event anyway if possible).
 * 
 * Usage: Paste into your theme before the jQuery handler script. Backend: Parse `rocket` from query.
 *        Test: Network tab > POST to /cart/item/add should include ?rocket=6-019a42d9-...
 * 
 * Dependencies: Global window.LogRocket (defer ok).
 */

document.addEventListener('click', e => {
  // Selector: Full URL match
  const targetButton = e.target.closest('button[data-link*="https://shopify.trophydepot.com/cart/item/add"]');
  if (!targetButton) {
    return;
  }

  const actualTarget = targetButton;

  // Sync: Check for sessionURL (available post-acceptance)
  if (window.LogRocket && LogRocket.sessionURL) {
    try {
      const parsedUrl = new URL(LogRocket.sessionURL);
      const pathParts = parsedUrl.pathname.split('/');
      const hash = pathParts[4];  // For /.../s/{hash}/0 format

      // Quick validation
      if (hash && hash !== 's' && hash.length > 10) {
        // Append rocket to data-link
        let dataLink = actualTarget.getAttribute('data-link');
        const linkUrl = new URL(dataLink, window.location.origin);
        linkUrl.searchParams.set('rocket', hash);
        dataLink = linkUrl.toString();

        actualTarget.setAttribute('data-link', dataLink);

        // Optional track
        const itemId = linkUrl.searchParams.get('id') || 'N/A';
        LogRocket.track('cart_add_click', { cartItemId: itemId, sessionHash: hash });
      }
    } catch (err) {
      // Silent fail—let bubble without rocket
      console.warn('LogRocket session not found.');
    }
  }

  // Event bubbles to jQuery handler—no further action needed

}, true);  // Capture phase: Runs before bubbling jQuery on('click')

/**
 * LogRocket Identify: Associates the LogRocket session with the cart hash
 * for Galileo Highlights API session lookups.
 *
 * Reads the CART_HASH meta tag (set from ShopifyAnalytics.uniqToken) and
 * calls identify() once. The Galileo API can then retrieve sessions by
 * this cart hash, filtering by date range for one-to-one matching.
 */
(function() {
  function identifyFromCartHash() {
    var meta = document.querySelector('meta[name="CART_HASH"][content]');
    if (meta && meta.getAttribute('content').trim() !== '' && window.LogRocket) {
      LogRocket.identify(meta.getAttribute('content'));
      return true;
    }
    return false;
  }

  // Try immediately (meta tag may already exist)
  if (identifyFromCartHash()) return;

  // Fallback: CART_HASH meta is injected async via ShopifyAnalytics
  var observer = new MutationObserver(function() {
    if (identifyFromCartHash()) {
      observer.disconnect();
    }
  });

  observer.observe(document.head, { childList: true, subtree: true });
})();